import React from 'react';
import { getWpBlock } from './index';
import WpDefaultHtml from './wp-default-html';
import { WPBlock, WPBlockProps } from './types';

interface ColumnProp {
  index: number;
  block: WPBlock;
  parentLength: number;
  ignoreColumns?: boolean;
  prefix?: string;
}

function createColumn({
  index,
  block,
  parentLength,
  ignoreColumns = false,
  prefix,
}: ColumnProp): JSX.Element | null {
  if (
    block?.attributes?.className?.includes('columns-gallery-tile--no-image')
  ) {
    // console.log(block);
  }

  const galleryTileNoImageStyle = block?.attributes?.className?.includes(
    'columns-gallery-tile--no-image',
  )
    ? 'columns-gallery-tile--no-image'
    : '';

  const blockCount = block?.innerBlocks?.length ?? 0;
  if (blockCount == 0) {
    if (!block.attributes.id) {
      return null;
    }
    return (
      <WpDefaultHtml
        key={block.attributes.id}
        block={block}
        parentLength={parentLength}
        prefix={prefix}
      />
    );
  }

  let classDef = '';
  let colClass = '';
  if (!ignoreColumns) {
    classDef = parentLength ? 'col-count-' + parentLength : '';
    colClass = block?.attributes?.className || 'col';
    classDef += prefix ? ' ' + prefix + 'col-count-' + parentLength : '';
    colClass += prefix ? ' ' + prefix + 'col' : '';
  }

  const key = 'col-' + (prefix ? prefix + 'col-' : '') + index;

  return (
    <div
      key={key}
      className={`${colClass} ${classDef} ${galleryTileNoImageStyle}`}
    >
      {block.innerBlocks.map((innerCol, innerIndex) => {
        const InnerWpBlock = getWpBlock(innerCol.__typename);
        if (!InnerWpBlock) return null;

        const innerKey = 'innercol' + key + '-' + innerIndex;
        if (!innerCol.attributes?.id && !innerCol.innerBlocks) {
          // console.log(
          //   'inner col without id block',
          //   innerIndex,
          //   innerKey,
          //   innerCol,
          // );
          return (
            <WpDefaultHtml
              key={innerKey}
              block={innerCol}
              parentLength={parentLength}
              prefix={(prefix ? prefix : '') + 'deep-'}
            />
          );
        }
        return (
          <InnerWpBlock
            key={innerKey}
            block={innerCol}
            prefix={(prefix ? prefix : '') + 'deep-'}
          />
        );
      })}
    </div>
  );
}

function WPColumns(props: WPBlockProps): JSX.Element | null {
  const block = props.block;
  const columnsNum = block.innerBlocks?.length ?? 0;
  // Our graphQl query supports only 2-level of columns
  // This block is a 3-level columns and only contains the HTML content without
  // innerBlocks structure
  if (columnsNum === 0) {
    return <WpDefaultHtml block={props.block} parentLength={columnsNum} />;
  }

  const className = block?.attributes?.className ?? '';
  // const ignoreColumnsLayout = className.indexOf('ignore-columns-layout') >= 0;
  const skipColumn = (column) => {
    const allClassName = column?.attributes?.className ?? '';
    return allClassName.indexOf('skip-column') >= 0;
  };
  const styleClass = block?.attributes?.className ?? '';
  return (
    <div className={`columns ${styleClass}`}>
      {columnsNum > 0 &&
        block.innerBlocks
          .filter((column) => !skipColumn(column))
          .map((column, index) => {
            return createColumn({
              index: index,
              block: column,
              parentLength: columnsNum,
              ignoreColumns: false,
              prefix: 'pre-' + (props.prefix ? props.prefix : ''),
            });
          })}
    </div>
  );
}

export default WPColumns;
